import { axiosInstance } from 'boot/axios.js'

export async function widthMeasures(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: 'width-measures',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('widthMeasures', response.data.items)
    return response
  } catch (e) {
    throw e
  }
}

export async function heightMeasures(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: 'height-measures',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('heightMeasures', response.data.items)
    return response
  } catch (e) {
    throw e
  }
}

export async function rimMeasures(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: 'rim-measures',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('rimMeasures', response.data.items)
    return response
  } catch (e) {
    throw e
  }
}
